import { Validators } from '@angular/forms';
import { PolluxFormConfig } from '../../../../../components/common/pollux-form-config/pollux-form-config';
import { PolluxFormDisabledEvaluator } from '../../../../../components/common/pollux-form-disabled-evaluator/pollux-form-disabled-evaluator';
import { PolluxValidators } from '../../../../../components/common/pollux-validators/pollux-validators';
import { ReportsValidators } from './reports-validators';

export const reportsFormConfig: PolluxFormConfig[] = [
  {
    name: 'Oid',
    value: 'Oid',
    disabled: true
  },
  {
    name: 'RecordStatusId',
    value: 'RecordStatusId'
  },
  {
    name: 'PropertyName',
    value: 'PropertyName',
    disabled: true,
    validators: [Validators.maxLength(100)]
  },
  {
    name: 'PropertyTypeId',
    value: 'PropertyTypeId',
    disabled: true
  },
  {
    name: 'ProjectStdId',
    value: 'ProjectStdId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.isEditMode(), PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ProjectStdIdDescription',
    value: 'ProjectStdIdDescription',
    disabled: true
  },
  {
    name: 'ValuationProjectIdDescription',
    value: 'ValuationProjectIdDescription',
    disabled: true
  },
  {
    name: "PropertyIdDescription",
    value: "PropertyIdDescription",
    disabled: true
  },
  {
    name: 'LeadingMethodId',
    value: 'LeadingMethodId',
    validators: [Validators.min(1)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.fieldIsNotSet('DataImportedWithGroupId', 7), PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'PropertyId',
    value: 'PropertyId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.isEditMode(), PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ValuationProjectId',
    value: 'ValuationProjectId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.isEditMode(), PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'PropertyStreet',
    value: 'PropertyStreet',
    disabled: true,
    validators: [Validators.maxLength(100)]
  },
  {
    name: 'languageDefinitionId',
    value: 'languageDefinitionId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly(), PolluxFormDisabledEvaluator.fieldIsSet('PropertyId', 0)],
    validators: [Validators.min(1)],
  },
  {
    name: 'PropertyMunicapelDescription',
    value: 'PropertyMunicapelDescription',
    disabled: true,
    validators: [Validators.maxLength(255)]
  },
  {
    name: 'PropertyPostcode',
    value: 'PropertyPostcode',
    disabled: true,
    validators: [Validators.maxLength(5)]
  },
  {
    name: 'TemplateId',
    value: 'TemplateId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.fieldIsSet('PropertyId', 0), PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(0)],
    formReferencingValidators: [ReportsValidators.template()]
  },
  {
    name: 'PropertyRegionDescription',
    value: 'PropertyRegionDescription',
    disabled: true,
    validators: [Validators.maxLength(100)]
  },
  {
    name: 'PropertyCountryDescription',
    value: 'PropertyCountryDescription',
    disabled: true
  },
  {
    name: 'localCurrencyId',
    value: 'localCurrencyId',
    validators: [Validators.min(0), PolluxValidators.integer(false)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'reportCurrencyId',
    value: 'reportCurrencyId',
    validators: [Validators.min(0), PolluxValidators.integer(false)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'localUnitOfLengthId',
    value: 'localUnitOfLengthId',
    validators: [Validators.min(0), PolluxValidators.integer(false)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'reportUnitOfLengthId',
    value: 'reportUnitOfLengthId',
    validators: [Validators.min(0), PolluxValidators.integer(false)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ValuerId',
    value: 'ValuerId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ReportClientFreeText',
    value: 'ReportClientFreeText',
    validators: [Validators.maxLength(255)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'StatusId',
    value: 'StatusId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'OwnerUserId',
    value: 'OwnerUserId',
    disabled: true
  },
  {
    name: 'CreatedDate',
    value: 'CreatedDate',
    isDate: true,
    disabled: true
  },
  {
    name: 'inspectionDate',
    value: 'inspectionDate',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ValuationDate',
    value: 'ValuationDate',
    isDate: true,
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]

  },
  {
    name: 'inspectionTypeId',
    value: 'inspectionTypeId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ModifiedByUserId',//DisplayModel: ModifiedByUserIdDescription
    value: 'ModifiedByUserId',
    disabled: true
  },
  {
    name: 'ChangeDate',
    value: 'ChangeDate',
    isDate: true,
    disabled: true
  },
  {
    name: 'comment',
    value: 'comment',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ClientAssetReferenceNumber',
    value: 'ClientAssetReferenceNumber',
    validators: [Validators.maxLength(50)],
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'ReportArgusImportLastSyncStatusDescription',
    value: 'ReportArgusImportLastSyncStatusDescription',
    disabled: true
  },
  {
    name: 'ReportArgusImportLastSyncDate',
    value: 'ReportArgusImportLastSyncDate',
    isDate: true,
    disabled: true
  },
  {
    name: 'ReportArgusImportLastSyncBy',
    value: 'ReportArgusImportLastSyncBy',
    disabled: true
  },
  {
    name: 'ReportArgusImportPropertyAssetId',
    value: 'ReportArgusImportPropertyAssetId',
    disabled: false,
    validators: [PolluxValidators.integer(true)]
  },
  {
    name: 'ReportArgusImportValuatioDataFromArgusDescription',
    value: 'ReportArgusImportValuatioDataFromArgusDescription',
    disabled: true
  },
  {
    name: 'ReportArgusImportValuatioDataFromArgusLastObtained',
    value: 'ReportArgusImportValuatioDataFromArgusLastObtained',
    isDate: true,
    disabled: true
  },
  {
    name: 'OwnerBuId',
    value: 'OwnerBuId',
    disabled: true
  },
  {
    name: 'ModifiedBuId',
    value: 'ModifiedBuId',
    disabled: true
  },
  {
    name: 'DisplayValuesOverTimeId',
    value: 'DisplayValuesOverTimeId',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    validators: [Validators.min(1)]
  },
  {
    name: 'JllJobId',
    value: 'JllJobId'
  }
];
